require('./backdrop-filter-plugin');

(() => {
  const siteNavigation = document.getElementById('site-navigation');
  const navButton = document.getElementById('site-navigation-button');
  const megaNav = document.getElementById('site-meganav');
  const megaNavChildren = [
    ...document.querySelectorAll('#site-meganav .site-meganav-inner'),
    ...document.querySelectorAll('#site-meganav li'),
    ...document.querySelectorAll('#site-meganav h2'),
    ...document.querySelectorAll('#site-meganav .header-subscribe-form'),
  ];
  const searchButton = document.querySelector('.site-header__search-button');
  const searchFormTop = document.querySelector('.main-menu-container .search-form');
  const siteNavCta = document.getElementById('site-navigation-cta');
  const siteNavLogo = document.querySelector('.site-header__logo');
  const mainArea = document.getElementById('primary');

  // Return early if the navigation doesn't exist.
  if (siteNavigation === null
    || navButton === null
    || megaNav === null
    || mainArea === null
    || siteNavCta === null
    || siteNavLogo === null
    || searchButton === null
    || searchFormTop === null) {
    return;
  }

  const mm = gsap.matchMedia();
  const breakpoint = 1024;
  let isDesktop;

  const trap = window.focusTrap.createFocusTrap(
    siteNavigation,
    {
      fallbackFocus: siteNavigation,
    },
  );
  const megaNavTimeline = gsap.timeline({
    paused: true,
    onComplete: () => {
      if (!isDesktop) {
        trap.activate();
      }
    },
    onReverseComplete: () => {
      if (!isDesktop) {
        trap.deactivate();
      }
    },
  });
  const siteNavCtaTimeline = gsap.timeline({ paused: true });
  const searchButtonTimeline = gsap.timeline({
    paused: true,
  })
    .fromTo(
      searchButton,
      {
        opacity: '1',
      },
      {
        opacity: '0',
        duration: 0.5,
      },
    )
    .fromTo(searchButton, {
      display: 'flex',
    }, {
      display: 'none',
      duration: 0.01,
    })
    .fromTo(searchFormTop, {
      display: 'none',
    }, {
      display: 'flex',
      duration: 0.01,
    });

  mm.add(`(max-width: ${breakpoint - 1}px)`, () => {
    isDesktop = false;

    megaNavTimeline
      .fromTo(
        megaNav,
        {
          opacity: '0',
          width: '0px',
          padding: 0,
          visibility: 'hidden',
          transformOrigin: '100% 50%',
        },
        {
          opacity: '1',
          width: '100%',
          padding: 'var(--nav-height) var(--padding-x) 1.25rem',
          visibility: 'visible',
          ease: 'power1',
          duration: 0.5,
          delay: 0.25,
        },
      )
      .fromTo(
        megaNavChildren,
        {
          opacity: '0',
        },
        {
          opacity: '1',
          // stagger: 0.1,
        },
      );
    siteNavCtaTimeline
      .fromTo(
        siteNavCta,
        {
          display: 'none',
          opacity: 0,
        },
        {
          display: 'flex',
          opacity: 1,
          duration: 0.5,
          delay: 0.5,
        },
      );
    searchButtonTimeline
      .fromTo(
        searchFormTop,
        {
          opacity: '0',
          width: '0',
          height: '0',
          transformOrigin: '50% 100%',
          translate: '0px -50%',
        },
        {
          opacity: '1',
          width: '18rem',
          height: 'auto',
          pointerEvents: 'auto',
          duration: 0.5,
        },
      );
  });

  mm.add(`(min-width: ${breakpoint}px)`, () => {
    isDesktop = true;

    megaNavTimeline
      .fromTo(
        megaNav,
        {
          opacity: '0',
          width: '0px',
          padding: 0,
          visibility: 'hidden',
          transformOrigin: '100% 50%',
        },
        {
          opacity: '1',
          width: '100%',
          padding: 'var(--nav-height) var(--padding-x) 1.25rem',
          visibility: 'visible',
          ease: 'power1',
          duration: 0.5,
          delay: 0.25,
        },
      )
      .fromTo(
        megaNavChildren,
        {
          opacity: '0',
        },
        {
          opacity: '1',
          // stagger: 0.1,
        },
      );
    siteNavCtaTimeline
      .fromTo(
        siteNavCta,
        {
          display: 'flex',
          opacity: 1,
        },
        {
          display: 'flex',
          opacity: 1,
          duration: 0.5,
          delay: 0.5,
        },
      );
    searchButtonTimeline
      .fromTo(
        searchFormTop,
        {
          opacity: '0',
          width: '0',
          height: '0',
          transformOrigin: '50% 100%',
          translate: '0px -50%',
        },
        {
          opacity: '1',
          width: '22rem',
          height: 'auto',
          pointerEvents: 'auto',
          duration: 0.5,
        },
      );
  });

  const openNavMenu = () => {
    closeSearch();
    megaNavTimeline.play();
    navButton.classList.add('is-expanded');
    navButton.setAttribute('aria-expanded', true);
    megaNav.classList.remove('pointer-events-none');
    megaNav.setAttribute('aria-hidden', false);
    window.bodyScrollLock.disableBodyScroll(megaNav);
    if (isDesktop) {
      siteNavLogo.removeAttribute('tabindex');
      searchButton.removeAttribute('tabindex');
    } else {
      siteNavCtaTimeline.play();
      siteNavLogo.setAttribute('tabindex', -1);
      searchButton.setAttribute('tabindex', -1);
    }
  };

  const closeNavMenu = () => {
    megaNavTimeline.reverse();
    navButton.classList.remove('is-expanded');
    navButton.setAttribute('aria-expanded', false);
    megaNav.classList.add('pointer-events-none');
    megaNav.setAttribute('aria-hidden', true);
    window.bodyScrollLock.enableBodyScroll(megaNav);
    if (!isDesktop) {
      siteNavCtaTimeline.reverse();
      siteNavLogo.removeAttribute('tabindex');
      searchButton.removeAttribute('tabindex');
    }
  };

  function handleMegaNavTabIndex(expanded) {
    const megaNavChildLinks = document.querySelectorAll('#site-meganav li a');
    megaNavChildLinks.forEach((link) => {
      if (expanded) {
        link.removeAttribute('tabindex');
      } else {
        link.setAttribute('tabindex', -1);
      }
    });
  }
  handleMegaNavTabIndex(false);

  function navToggle() {
    const expanded = navButton.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      closeNavMenu();
    } else {
      openNavMenu();
    }
    handleMegaNavTabIndex(!expanded);
  }
  navButton.addEventListener('click', navToggle);

  function openSearch() {
    searchButtonTimeline.play();
    searchButton.setAttribute('aria-expanded', true);
  }

  function closeSearch() {
    searchButtonTimeline.reverse();
    searchButton.setAttribute('aria-expanded', false);
  }

  function searchToggle() {
    const expanded = searchButton.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      closeSearch();
    } else {
      openSearch();
      closeNavMenu();
    }
  }
  searchButton.addEventListener('click', searchToggle);
})();
